const TELEMETRY_PATH_MAX_LENGTH = 120;

/**
 * アプリ内復帰用パスか。
 * `/` 始まりかつ `//` 始まりでないもののみ (open redirect / scheme-relative を拒否)。
 */
export const isInternalAppPath = (path: string): boolean =>
  path.startsWith("/") && !path.startsWith("//");

/**
 * navigateToExternal で許可する URL か (絶対 URL のみ)。
 * https かつ自ホスト / *.circle.ms / circle.ms / x.com
 * 同一オリジン相対パスのフルリロードは navigateToRoute(..., { forceExternal: true }) を使う。
 */
export const isAllowedExternalNavigationUrl = (
  url: string,
  currentHostname?: string
): boolean => {
  if (!url || url.startsWith("/") || url.startsWith("//")) {
    return false;
  }
  try {
    const parsed = new URL(url);
    if (parsed.protocol !== "https:") {
      return false;
    }
    const host = parsed.hostname.toLowerCase();
    const selfHost = (currentHostname ?? (import.meta.client ? window.location.hostname : "")).toLowerCase();
    if (selfHost && host === selfHost) {
      return true;
    }
    if (host === "circle.ms" || host.endsWith(".circle.ms")) {
      return true;
    }
    // Intl SNS (COMIKE_SNS_X) と共通規則
    if (host === "x.com") {
      return true;
    }
    return false;
  }
  catch {
    return false;
  }
};

/**
 * Telemetry 向けに query/hash を除き pathname のみ残し、長さを制限する。
 */
export const sanitizePathForTelemetry = (path: string): string => {
  if (!path) {
    return "";
  }
  let pathname = path;
  try {
    if (/^https?:\/\//i.test(path)) {
      pathname = new URL(path).pathname;
    }
    else {
      pathname = path.split(/[?#]/, 1)[0] ?? "";
    }
  }
  catch {
    pathname = "(invalid)";
  }
  if (pathname.length <= TELEMETRY_PATH_MAX_LENGTH) {
    return pathname;
  }
  return `${pathname.slice(0, TELEMETRY_PATH_MAX_LENGTH)}…`;
};
